import React, { Component } from 'react';

import CheatPanel from './cheat_panel/containers/CheatPanelContainer';
import ControlPanel from './control_panel/ControlPanel';
import HistoryPanel from './history_panel/HistoryPanel';
import Gameboard from './gameboard/containers/GameboardContainer';
import SolvePanel from './solve_panel/SolvePanel';
import GeneralPanel from './general_panel/GeneralPanel';

import styles from './style';

const mobileComponent = (
  <div className={styles['container']}>
    <div className={styles['row']}>
      <GeneralPanel />
      <ControlPanel />
    </div>
    <div className={styles['row']}>
      <CheatPanel />
      <SolvePanel />
    </div>
    <div className={styles['row']}>
      <Gameboard />
    </div>
    <div className={styles['row']}>
      <HistoryPanel />
    </div>
  </div>);

const desktopComponent = (
  <div className={styles['container']}>
    <div className={styles['row']}>
      <GeneralPanel />
      <ControlPanel />
      <CheatPanel />
      <SolvePanel />
    </div>
    <div className={styles['row']}>
      <HistoryPanel />
      <div className={styles['gap']} />
      <Gameboard />
      <div className={styles['gap']} />
    </div>
  </div>
  );

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = { isMobile: true };
  }

  componentDidMount() {
    const screenWidth = window.matchMedia('(max-width: 900px)');
    const deviceWidth = window.matchMedia('(max-device-width: 1081px)');
    if (deviceWidth.matches) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ isMobile: true });
    } else {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ isMobile: screenWidth.matches });
      screenWidth.addEventListener('change', (e) => {
        this.setState({ isMobile: e.matches });
      });
    }
  }

  render() {
    return (
      <div>
        {this.state.isMobile && (mobileComponent)}
        {!this.state.isMobile && (desktopComponent)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.jsx